import {GET, POST} from "../util";

const inspectionUrl = "api/industry-blacklist-inspection";
const operationUrl = "api/industry-blacklist-operation";

const url = {
	inspection: {
		blacklisted: `${inspectionUrl}/blacklisted`
	},
	operation: {
		save: `${operationUrl}/save`,
	}
};

const industryBlacklistApi = {
	inspection: {
		getBlacklisted: (accountId) => {
			return GET(url.inspection.blacklisted);
		}
	},
	operation: {
		save: (params = []) => {
			return POST(url.operation.save, params, "application/json", 'Array');
		}
	}
};

export {industryBlacklistApi};
